/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earlybirdinfobadge3Inputs */

const en_earlybirdinfobadge3 = /** @type {(inputs: Earlybirdinfobadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early bird subscribers info`)
};

const de_earlybirdinfobadge3 = /** @type {(inputs: Earlybirdinfobadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info für Early-Bird-Abos`)
};

/**
* | output |
* | --- |
* | "Early bird subscribers info" |
*
* @param {Earlybirdinfobadge3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earlybirdinfobadge3 = /** @type {((inputs?: Earlybirdinfobadge3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earlybirdinfobadge3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earlybirdinfobadge3(inputs)
	return de_earlybirdinfobadge3(inputs)
});
export { earlybirdinfobadge3 as "earlyBirdInfoBadge" }